import { Button, Card, Space, Typography } from '@sravni/react-design-system';

import { APP_DOWNLOAD_URL, TITLE_BUTTON } from 'features/MobileApp/config';
import { getStyles } from 'features/MobileApp/lib';

import CoinsPng from '../assets/phone_coins.png';
import type { TMobileAppViewProps } from '../types/MobileApp.types';

import styles from './MobileApp.module.scss';

export const MobileAppMobile = ({ title, subtitle, color }: TMobileAppViewProps) => {
  const goToAppLink = (redirectURL: string) => {
    window.location.href = redirectURL;
  };

  return (
    <Card
      color={color}
      size={16}
      className={styles.card}
    >
      <Space
        size={12}
        align="center"
        justify="space-between"
        direction="vertical"
      >
        <Space
          size={12}
          align="center"
          direction="vertical"
        >
          <img
            className={styles.coinsMobile}
            width={167}
            alt="coins"
            src={CoinsPng}
          />

          <Space
            size={4}
            direction="vertical"
            className={styles.textBlockMobile}
          >
            <Typography.Text
              size={16}
              strong
            >
              {title}
            </Typography.Text>
            <Typography.Text
              className="h-color-D60"
              size={14}
            >
              {subtitle}
            </Typography.Text>
          </Space>
        </Space>

        <Button
          {...getStyles(color)}
          onClick={() => goToAppLink(APP_DOWNLOAD_URL)}
        >
          {TITLE_BUTTON}
        </Button>
      </Space>
    </Card>
  );
};
